<span [ngSwitch]="runStatus" class="experiment-tracking-status">
    <i *ngSwitchCase="'FINISHED'" class="icon-check-sign success"></i>
    <i *ngSwitchCase="'RUNNING'" class="icon-play running"></i>
    <i *ngSwitchCase="'SCHEDULED'" class="icon-calendar scheduled"></i>
    <i *ngSwitchCase="'FAILED'" class="icon-remove-sign failed"></i>
    <i *ngSwitchDefault class="icon-ban-circle killed"></i>
</span>